import { render, staticRenderFns } from "./FavouriteButton.vue?vue&type=template&id=4657b54e&"
import script from "./FavouriteButton.vue?vue&type=script&setup=true&lang=js&"
export * from "./FavouriteButton.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports